import { __assign, __rest } from "tslib";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
var BiOption = function (_a) {
    var biData = _a.biData, innerRef = _a.innerRef, stopPropagation = _a.stopPropagation, props = __rest(_a, ["biData", "innerRef", "stopPropagation"]);
    // _value is used in useBiClickLogger to compare with
    //  the parent select's value and recognize a change
    // so add it automatically if it's not there
    if (biData && props.value) {
        biData._value = biData._value || props.value.toString();
    }
    var setTrackingRef = useBiClickLogger(biData, stopPropagation).setTrackingRef;
    return (React.createElement("option", __assign({}, props, { ref: function (node) {
            setTrackingRef(node);
            innerRef && innerRef(node);
        } })));
};
BiOption.displayName = 'BiOption';
export default BiOption;
//# sourceMappingURL=BiOption.js.map